<template>

	<div>
		<div v-if="permissions.add" class="btns-top">
			<router-link class="btn btn-add  fa fa-plus transition-fadeinup transition-delay-01" :to="`/${mainslug}/${entityid}/add`"></router-link>
		</div>

		<div class="row" v-if="this.totalCount === 0">
			<div class="col-20">

				<div class="addFirstItem transition-fadeinup">
					<p>No items found!<br><br></p>
					<router-link class="btn transition-fadeinup transition-delay-01" :to="`${entityid}/add`">
						<span class="fa fa-plus"></span> Add first item
					</router-link>
				</div>

			</div>
		</div>

		<table cellpadding="0" cellspacing="0" class="data  transition-fadeinup" v-if="this.totalCount > 0">
			<thead v-if="columns">
			<tr>
				<th></th>
				<th v-for="column in columns" :key="column.id">
					<button class="btn-sort" :data-table-column="column.name" :data-sort="direction(column.name)" @click="sortBtnClickHandler">{{ column.translations.en.value }}</button>
				<th>
					<button class="btn-sort" data-table-column="state" :data-sort="direction('state')" @click="sortBtnClickHandler">Published</button>
				</th>
				<th></th>
				<th></th>
			</tr>
			</thead>

			<tbody class="draggable-container">
			<template v-for="user in items">
				<tr v-bind:key="user.id" class="draggable-item" :data-uuid="user.uuid">
					<td></td>

					<template v-for="column in columns">
						<template v-if="user.properties[column.name]">
							<td v-html="renderColumnField(user, items, markets, column, linkedEntity)" :key="column.id"></td>
						</template>
						<template v-else>
							<td :key="column.id"></td>
						</template>
					</template>

					<td class="toggle-wrapper">
						<a href="#" class="btn-multi-switch" :class="`${ getMultiSwitchClass(user.state) }`" :data-id="user.id" v-on:click="stateToggleChangeHandler">
							<input type="number" name="state-toggle" :value="user.state"> </a>
					</td>
					<td class="btns">
						<router-link v-if="permissions.edit" :to="`/${mainslug}/${entityid}/edit/${user.uuid}`"><i class="fa fa-pen"></i></router-link>
						<a v-if="permissions.delete" href="#" class="btn-delete-confirm fa fa-trash-alt" :id="user.uuid"></a>
					</td>
					<td></td>
				</tr>
			</template>

			</tbody>
		</table>

		<div class="bubble bubble-delete-confirm">
			<a href="" class="btn red btn-bubble-delete" v-on:click="deleteRecord">Confirm</a>
			<a href="" class="btn black btn-bubble-cancel">Cancel</a>
		</div>
	</div>

</template>

<script>

import xhrModule from '../../modules/xhrModule.js'
import general from '../../modules/general.js'

export default {
	name: 'overview',

	data () {
		return {
			items: [],
			totalCount: 0,
			columns: null,
			entityid: null,
			entity: null,
			mainslug: this.getMainSlug(),
			user: this.$store.state.user,
			markets: null,
			linkedEntity: null,
			permissions: {
				add: false,
				edit: false,
				delete: false
			},
			sortProp: null,
			sortDirection: null
		}
	},

	created () {
		this.loadingInt = 0
		this.fetchData()
	},

	methods: {
		direction (name) {
			if (name === this.sortProp) {
				return this.sortDirection
			} else {
				return ''
			}
		},

		fetchData () {
			document.querySelector('body').classList.add('loading')
			// get column data from the entity
			var url = '/cms/api/entities?name=' + this.mainslug
			xhrModule.get(url, this.usersEntityFetchCompleted.bind(this))

			// get all instances for entity with name users
			var url1 = '/cms/api/instances/ofEntity?entity=' + this.mainslug
			xhrModule.get(url1, this.usersFetchCompleted.bind(this))
		},

		usersEntityFetchCompleted (data) {
			data = data.data
			this.entityid = data.id
			this.entity = data

			this.fetchSavedSorting()

			var permissions = general.checkPermissions(data.privileges, this.user.roles)
			this.permissions = permissions

			// now we can define the columns that we want to show
			var properties = data.properties
			var sortable = []
			for (var prop in properties) {
				if (!properties[prop].translations) continue
				if (!properties[prop].settings) continue
				if (properties[prop].settings.orderinoverview.value === '0') continue
				sortable.push(properties[prop])
			}

			sortable.sort(function (a, b) {
				return a.settings.orderinoverview.value - b.settings.orderinoverview.value
			})

			this.tempColumns = sortable
			this.loadingFinished()
		},

		usersFetchCompleted (data) {
			this.linkedEntity = data.linked
			// filter out all doubles
			var foundUUIDS = []
			var filteredUsers = []
			for (var key in data.data) {
				var uuid = data.data[key].uuid
				// make sure the admin and unauthenticated user are not visible in the overview
				if (uuid === '11EAA96C12CE06A4AC16005056982405' || uuid === '11EA997CE21A8EA7AC16005056982405') continue
				// also our admin@three-sixty.be and unauthenticated user should not be shown
				if (uuid === '11EAA742E11D75BDAC16005056982405' || uuid === '11EAA96C1F4ED249AC16005056982405') continue
				if (foundUUIDS.indexOf(uuid) === -1) {
					filteredUsers.push(data.data[key])
					foundUUIDS.push(uuid)
				}
			}

			this.allItems = data.data
			this.tempItems = filteredUsers

			this.loadingFinished()
		},

		loadingFinished () {
			this.loadingInt++
			if (this.loadingInt === 2) {
				this.columns = this.tempColumns
				this.items = this.tempItems
				this.totalCount = this.items.length

				this.findRealTextValuesForReferences(function () {
					this.sortResults()
				}.bind(this))

				this.loadingInt = 0
				document.querySelector('body').classList.remove('loading')
			}
		},

		findRealTextValuesForReferences: function (callback) {
			// we need to find all arrays and find their real text values so we can sort on them instead of the uuids
			var referenceFields = this.linkedEntity.references
			for (var i = this.items.length - 1; i >= 0; i--) {
				for (var ref in referenceFields) {
					var value = this.items[i].properties[ref]

					if (value) {
						if (!this.items[i]['ref-' + ref]) this.items[i]['ref-' + ref] = ''
						for (var v = 0; v < value.length; v++) {
							var languages = referenceFields[ref][value[v]]
							for (var lang in languages) {
								if (this.items[i].market === languages[lang].market) {
									this.items[i]['ref-' + ref] += languages[lang].properties.name
								}
							}
						}
					}
				}

				if (i === 0) {
					callback()
				}
			}
		},

		stateToggleChangeHandler (e) {
			var target = e.currentTarget
			var input = target.querySelector('input')

			clearTimeout(this.debounceStateToggle)

			this.debounceStateToggle = setTimeout(function () {
				var value = input.value
				var instanceID = target.getAttribute('data-id')

				var obj = {
					'entity': null,
					'uuid': null,
					'instance': []
				}

				// find all instances with this UUID and set their state to 5
				for (var i = this.items.length - 1; i >= 0; i--) {
					var parsedID = parseInt(instanceID)
					if (this.items[i].id === parsedID) {
						if (!obj.entity) {
							obj.entity = this.entityid
							obj.uuid = this.items[i].uuid
						}

						obj.instance.push({
							'id': this.items[i].id,
							'market': this.items[i].market,
							'state': value
						})

						var json = JSON.stringify(obj)

						var url = '/cms/api/instances/save'
						xhrModule.post(url, json, this.updatedInstanceCompleteHandler.bind(this))

						break
					}
				}
			}.bind(this), 300)
		},

		updatedInstanceCompleteHandler (data) {
			general.saveAnimation()
		},

		deleteRecord (e) {
			e.preventDefault()

			var target = e.currentTarget
			var uuid = target.getAttribute('data-id')

			var obj = {
				'entity': null,
				'uuid': null,
				'instance': []
			}

			// find all instances with this UUID and set their state to 5
			for (var i = this.allItems.length - 1; i >= 0; i--) {
				if (this.allItems[i].uuid === uuid) {
					if (!obj.entity) {
						obj.entity = this.entityid
						obj.uuid = this.allItems[i].uuid
					}

					obj.instance.push({
						'id': this.allItems[i].id,
						'market': this.allItems[i].market,
						'state': 5
					})
				}

				if (i === 0) {
					var json = JSON.stringify(obj)

					var url = '/cms/api/instances/save'
					xhrModule.post(url, json, this.deletedInstanceCompleteHandler.bind(this))
				}
			}
		},

		deletedInstanceCompleteHandler (data) {
			general.saveAnimation()
			this.fetchData()
		},

		getMainSlug () {
			var pathName = window.location.pathname
			var path = pathName.split('/')[2]
			if (path === 'overview') path = 'users'
			return path
		},

		sortBtnClickHandler (e) {
			e.preventDefault()

			var target = e.currentTarget
			var column = target.getAttribute('data-table-column')
			var sort = target.getAttribute('data-sort')

			// reset previous sort target
			if (this.previousSortTarget) {
				if (this.previousSortColumn !== column) this.previousSortTarget.setAttribute('data-sort', '')
			}

			this.previousSortTarget = target
			this.previousSortColumn = column

			switch (sort) {
				case '':
					sort = 'asc'
					break
				case 'asc':
					sort = 'desc'
					break
				case 'desc':
					sort = ''
					break
			}

			target.setAttribute('data-sort', sort)
			this.sortProp = column
			this.sortDirection = sort

			if (sort === '') {
				// remove item
				localStorage.removeItem('cms_sort_' + this.entityid)
			} else {
				// save chosen sorting
				var sortObj = {
					'property': column,
					'direction': sort
				}
				localStorage.setItem('cms_sort_' + this.entityid, JSON.stringify(sortObj))
			}
			this.sortResults()
		},

		sortResults () {
			// sort items
			this.items.sort(function (a, b) {
				if (!this.sortDirection) {
					// sort by ID
					if (a.id < b.id) {
						return -1
					}

					if (a.id > b.id) {
						return 1
					}
				} else {
					if (this.sortProp === 'state') {
						// sort on state
						if (a.state < b.state) {
							return this.sortDirection === 'asc' ? -1 : 1
						}

						if (a.state > b.state) {
							return this.sortDirection === 'asc' ? 1 : -1
						}
					} else {
						// sort on property
						var propA = null
						var propB = null
						if (this.entity.properties[this.sortProp].settings.type.value === 'Reference') {
							propA = a['ref-' + this.sortProp]
							propB = b['ref-' + this.sortProp]
						} else {
							propA = a.properties[this.sortProp]
							propB = b.properties[this.sortProp]
						}

						// when the prop is a string we can lowercase it to prevent case sensitivity
						if (typeof propA === 'string') {
							propA = propA.toLowerCase()
							propB = propB.toLowerCase()
						}

						if (propA < propB) {
							return this.sortDirection === 'asc' ? -1 : 1
						}

						if (propA > propB) {
							return this.sortDirection === 'asc' ? 1 : -1
						}
					}
				}

				return 0
			}.bind(this))
		},

		fetchSavedSorting () {
			// fetch saved sorting value
			var savedSorting = localStorage.getItem('cms_sort_' + this.entityid)
			if (savedSorting) {
				savedSorting = JSON.parse(savedSorting)
				this.sortProp = savedSorting.property
				this.sortDirection = savedSorting.direction
			}
		}
	},

	watch: {
		$route (to) {
			this.items = []
			this.columns = null
			this.mainslug = this.getMainSlug()
			this.entityid = null
			this.fetchSavedSorting()
			this.fetchData()
		}
	}
}

</script>
